import { render, staticRenderFns } from "./AddFeeType.vue?vue&type=template&id=0a104a54&scoped=true"
import script from "./AddFeeType.vue?vue&type=script&lang=js"
export * from "./AddFeeType.vue?vue&type=script&lang=js"
import style0 from "./AddFeeType.vue?vue&type=style&index=0&id=0a104a54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a104a54",
  null
  
)

export default component.exports